module.exports = __webpack_public_path__ + "img/nt59-00-80-1.prt.9c7411c8.jpg";